import type { FilterOptions } from '../mapFilters';

const optionHasEqualValue = (option: string[], value: string | undefined) =>
  option.some((optionValue) => optionValue === value);

export const filterByValueEqual = (
  value: string | undefined,
  { exclude, include }: FilterOptions
) => {
  const flags = {
    shouldInclude: false,
    shouldExclude: false
  };

  // Если есть такой value, то не пускаем
  if (exclude.length) {
    flags.shouldExclude = optionHasEqualValue(exclude, value);
  }

  // Пускаем, если есть такой value в include
  if (include.length) {
    flags.shouldInclude = optionHasEqualValue(include, value);
  }

  return flags;
};
